import { t } from 'i18n';
import { formatDate, formatNumber } from 'i18n/format';

export const fmtDate = (iso) => iso ? formatDate(iso, { dateStyle: 'medium', timeStyle: 'short' }) : '—';
export const fmtNumber = (number) => number === null || number === undefined ? '—' : formatNumber(number);

export function fmtRelative(iso) {
  if (!iso) return t('data.never');
  const seconds = Math.round((Date.now() - new Date(iso).getTime()) / 1000);
  if (seconds < 60) return t('data.justNow');
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return t('data.minutesAgo', { count: minutes, amount: formatNumber(minutes) });
  const hours = Math.round(minutes / 60);
  if (hours < 24) return t('data.hoursAgo', { count: hours, amount: formatNumber(hours) });
  const days = Math.round(hours / 24);
  if (days < 30) return t('data.daysAgo', { count: days, amount: formatNumber(days) });
  return fmtDate(iso);
}
